import { QueryParameters as GetCartQueryParams } from "@faire/web-api--source/endpoints/www/api/v2/carts/cartToken/get";
import { BrandCartsSortBy } from "@faire/web-api--source/faire/carts/BrandCartsSortBy";
import { useCallback } from "react";

type BuildQueryParamsArg = {
  brandToken: string;
  isSideCart?: boolean;
};

export const useBrandCartQueryParams = () => {
  return useCallback(({ brandToken, isSideCart }: BuildQueryParamsArg) => {
    return getCartQueryParams(brandToken, isSideCart);
  }, []);
};

const getCartQueryParams = (brandToken: string, isSideCart?: boolean) => {
  return GetCartQueryParams.build({
    brand_tokens: [brandToken],
    exclude_alcohol_disclaimer: false,
    sort_brand_carts_by: BrandCartsSortBy.UPDATED_AT,
    should_collapse_preorder_groups: true,
    is_side_cart: isSideCart,
  });
};
